import { render, staticRenderFns } from "./PartnerFormSavingModal.vue?vue&type=template&id=450be239&scoped=true&"
import script from "./PartnerFormSavingModal.vue?vue&type=script&lang=ts&"
export * from "./PartnerFormSavingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFormSavingModal.vue?vue&type=style&index=0&id=450be239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450be239",
  null
  
)

export default component.exports